import '../datasift/twitter_content.js.coffee';# Added by Script 
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TwitterApiContent extends Monitoring.Models.SocialContents.TwitterContent

  initialize: (args) ->
    super(args)
    @user = @get('user') or @get('sender') or @interaction().user or @get('data').sender or @get('data').interaction.author

  hasRoot: ->
    @get('data').in_reply_to_status_id?

  getRootParentId: ->
    @get('data').in_reply_to_status_id

  getImmediateParentId: ->
    ''

  type: ->
    return 'twitter'

  subType: ->
    return @get('data').sub_type if @get('data').sub_type

    if @get('data').sender_id
      return 'direct-message'
    else
      return 'tweet'

  newSubType: ->
    if @subType() == 'tweet' && @hasRoot()
      'tw-reply'
    else
      super()

  isPrivateMessage: ->
    @subType() == 'direct-message'

  content: ->
    @get('data').interaction?.content || @interaction().text

  avatar: ->
    return @user.profile_image_url_https or @user.avatar

  username: ->
    return @screen_name()

  screen_name: ->
    return @user.screen_name or @user.username

  name: ->
    return @user.name

  retweet_count: ->
    return @interaction().retweeted_status?.retweet_count

  tweet_id: ->
    @get('data').id_str

  interaction: ->
    @get('data') or @attributes

  links: ->
    @interaction().interaction?.links

  media_contains: (link) ->
    contains = false
    medias = @getMedias()
    if medias
      contains = contains || (media.expanded_url == link) for media in medias
    contains

  link_media_url: (link) ->
    if @media_contains(link)
      medias = @getMedias()
      for media in medias
        return @url_to(media)
    else if link.match(/\.(jpeg|jpg|gif|png)$/) != null
      return link
    super(link)

  url_to: (media) ->
    if media.type == 'animated_gif' && @canPlayVideoType('video/mp4')
      return media.video_info.variants[0].url
    else
      return media.media_url

  userLink: ->
    return "https://twitter.com/intent/user?screen_name=#{@username()}"

  contentUrl: ->
    if !@isPrivateMessage()
      "https://twitter.com/#{@username()}/status/#{@tweet_id()}"

  userId: ->
    return @user.id_str or @user.id

  getMedias: ->
    if @get('data').extended_entities?.media?
      @get('data').extended_entities.media
    else if @get('data').entities?.media?
      @get('data').entities.media
    else if @get('data').attachment? && @get('data').attachment.type == 'media'
      [@get('data').attachment.media]
    else
      []